import React from 'react';
import { Button } from './ui/button';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

const HeroSection = () => {
  return (
    <section className="pt-24 md:pt-32 pb-16 md:pb-24 bg-[#FDFBF7]" data-testid="hero-section">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          {/* Left Content */}
          <motion.div
            className="lg:col-span-7"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: 'easeOut' }}
          >
            <h1 
              className="font-heading text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight text-[#292524] leading-[1.1] text-balance"
              data-testid="hero-headline"
            >
              You've made peace with giving up your data.{' '}
              <span className="text-[#0D9488]">Have you made peace with giving up theirs?</span>
            </h1>
            
            <p 
              className="mt-8 text-lg md:text-xl leading-relaxed text-[#78716C] max-w-2xl"
              data-testid="hero-subhead"
            >
              Every app your family uses comes with terms most parents never read — terms that can change without warning, expose your children without your knowledge, and carry risks that look different for every family. SaidSimply™ monitors every agreement automatically, translates the legal language into plain English, and scores the risk against your family's unique profile.
            </p>

            <div className="mt-10 flex flex-col sm:flex-row gap-4">
              <Button
                size="lg"
                className="rounded-full bg-[#0D9488] hover:bg-[#0F766E] text-white px-8 py-6 text-lg font-medium shadow-lg shadow-teal-900/10 hover:shadow-teal-900/20 transition-all hover:-translate-y-0.5"
                data-testid="hero-cta-primary"
                asChild
              >
                <a href="https://app.trysaidsimply.com/auth">
                  Start Protecting My Family — Free for 14 Days
                  <ArrowRight className="ml-2 w-5 h-5" />
                </a>
              </Button>
            </div>
            
          </motion.div>

          {/* Right Image */}
          <motion.div
            className="lg:col-span-5"
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, delay: 0.2, ease: 'easeOut' }}
          >
            <div className="relative">
              <div className="absolute -inset-4 bg-[#0D9488]/5 rounded-3xl blur-2xl"></div>
              <img
                src="https://images.unsplash.com/photo-1714646793052-c6c625e967f0?crop=entropy&cs=srgb&fm=jpg&q=85&w=800"
                alt="Father and daughter reading together"
                className="relative rounded-3xl shadow-2xl w-full object-cover aspect-[4/5]"
                data-testid="hero-image"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
